export function getOperator (
  $bookings
){
  'ngInject';

  this.routes = $bookings.collections.routes;

  return ( input ) => {
    let result = '';
    this.routes.map(route => {
      if( route.uri == input ){
        result = route.operator;
      }
    } );
    return result;
  }

}


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/getOperator.filter.js
 **/